import { createContext } from 'react';
import { DEFAULT_SET_AND_UNSET_VALUE } from '../../internal/constants';
export default /*#__PURE__*/ createContext(DEFAULT_SET_AND_UNSET_VALUE);

//# sourceMappingURL=PerformanceMonitorTreeContext.js.map